export default __webpack_public_path__ + "static/media/09.54610935.jpg";